
export const IS_DEV = false;
export const ACC_KEY = IS_DEV
  ? "eea1bbda1f8835b27dd821a65c658ddb"
  : "78bbaf22a685df4951cf89c06f834d27";
export const POWERLEGO_API_URL = IS_DEV
  ? "https://dev.powerlego.com/ApiGateway"
  : "https://www.powerlego.com/ApiGateway";
